(function () {
  /**
   * =================================
   * CONFIG
   * =================================
   */
  var STORAGE_PREFIX = "first_";
  var ATTRIBUTION_KEYS = [
    "gclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "_fbc",
    "_fbp",
  ];
  var DEBUG = false; // set true temporarily during testing
  var MARKET_PROPERTY = "market";

  /**
   * =================================
   * SAFE HELPERS
   * =================================
   */
  function safeGetParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
      return null;
    }
  }

  function safeGetCookie(name) {
    try {
      var match = document.cookie.match(
        new RegExp("(^|;\\s*)" + name + "=([^;]+)"),
      );
      return match ? decodeURIComponent(match[2]) : null;
    } catch (e) {
      return null;
    }
  }

  function safeGetStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSetStorage(key, value) {
    try {
      if (value && !localStorage.getItem(key)) {
        localStorage.setItem(key, value);
      }
    } catch (e) {}
  }

  function log() {
    if (DEBUG && window.console) {
      console.log.apply(console, arguments);
    }
  }

  /**
   * =================================
   * FACEBOOK PARAM NORMALISATION
   * =================================
   */
  function ensureFacebookParams() {
    try {
      var params = new URLSearchParams(window.location.search);
      var fbclid = params.get("fbclid");

      if (!fbclid) return;

      var hasFbc = params.has("_fbc");
      var hasFbp = params.has("_fbp");

      if (hasFbc && hasFbp) return;

      // Prevent infinite reloads
      if (params.has("__fb_reload")) return;

      var now = Date.now();

      // --- _fbc ---
      if (!hasFbc) {
        var fbcCookie = safeGetCookie("_fbc");

        var fbc = fbcCookie || "fb.2." + now + "." + fbclid;

        params.set("_fbc", fbc);

        // Set cookie if missing
        if (!fbcCookie) {
          document.cookie =
            "_fbc=" +
            encodeURIComponent(fbc) +
            "; path=/; max-age=7776000; SameSite=Lax";
        }
      }

      // --- _fbp ---
      if (!hasFbp) {
        var fbpCookie = safeGetCookie("_fbp");

        var fbp =
          fbpCookie || "fb.2." + now + "." + Math.floor(Math.random() * 1e10);

        params.set("_fbp", fbp);

        // Set cookie if missing
        if (!fbpCookie) {
          document.cookie =
            "_fbp=" +
            encodeURIComponent(fbp) +
            "; path=/; max-age=7776000; SameSite=Lax";
        }
      }

      params.set("__fb_reload", "1");

      window.location.replace(
        window.location.pathname + "?" + params.toString(),
      );
    } catch (e) {
      // fail silently
    }
  }

  /**
   * =================================
   * CAPTURE FIRST TOUCH
   * =================================
   */
  function captureAttribution() {
    ATTRIBUTION_KEYS.forEach(function (key) {
      // Priority: URL param → cookie → existing storage
      var value =
        safeGetParam(key) ||
        safeGetCookie(key) ||
        safeGetStorage(STORAGE_PREFIX + key);

      if (value) {
        safeSetStorage(STORAGE_PREFIX + key, value);
        log("[Attribution] Captured", key, value);
      }
    });
  }

  /**
   * =================================
   * BUILD PAYLOAD FOR ALIA
   * =================================
   */
  function getStoredAttribution() {
    var props = {};

    ATTRIBUTION_KEYS.forEach(function (key) {
      var stored = safeGetStorage(STORAGE_PREFIX + key);
      if (stored) {
        props[key] = stored;
      }
    });

    return Object.keys(props).length ? props : null;
  }

  /**
   * =================================
   * MARKET (read at push time, not stored)
   * =================================
   */
  function getMarket() {
    try {
      var market = window.PLH_MARKET;
      if (market === "United Kingdom" || market === "Australia") {
        return market;
      }
      if (market === "uk") return "United Kingdom";
      if (market === "au") return "Australia";
    } catch (e) {}
    return null;
  }

  /**
   * =================================
   * PUSH INTO ALIA
   * =================================
   */
  function pushToAlia() {
    var properties = getStoredAttribution() || {};
    var market = getMarket();
    if (market) {
      properties[MARKET_PROPERTY] = market;
    }

    if (!Object.keys(properties).length) {
      log("[Attribution] No stored properties to push");
      return;
    }

    window.alia = window.alia || [];
    window.alia.push({
      type: "setProperties",
      properties: properties,
    });

    log("[Attribution] Pushed to Alia", properties);
  }

  /**
   * =================================
   * INIT
   * =================================
   */
  ensureFacebookParams();
  captureAttribution();
  setTimeout(captureAttribution, 1500);

  // Alia lifecycle hooks
  document.addEventListener("alia:popupView", pushToAlia);
  document.addEventListener("alia:signup", pushToAlia);
})();
